import { render, staticRenderFns } from "./BuildingBeingStatusList.vue?vue&type=template&id=0d38eff6&scoped=true&"
import script from "./BuildingBeingStatusList.vue?vue&type=script&lang=js&"
export * from "./BuildingBeingStatusList.vue?vue&type=script&lang=js&"
import style0 from "./BuildingBeingStatusList.vue?vue&type=style&index=0&id=0d38eff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d38eff6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCol,VContainer,VLabel,VRow})
